module.exports = __webpack_public_path__ + "static/img/linefriends.78195f5c.jpg";